<template>
    <div>
    	<header class="mui-bar mui-bar-nav">
			<a class="mui-icon mui-icon-left-nav mui-pull-left" @click="$router.push({path: '/home'});"></a>
			<h1 class="mui-title">消息中心</h1>
		</header>
		<div class="mui-content" v-if="msgList.length>0">
			<div class="msgBox" v-for="(msg,index) in msgList" :key="index" >
				<span class="mui-badge">{{msg.create_time}}</span>
				<div class="mui-card myCard">
					<!--页眉，放置标题-->
					<div class="mui-card-header msgTitle">{{msg.title}}</div>
					<span class="gotoAdd" @click="goAddMoney">{{msg.type== '1'?"立即充值":""}}</span>
					<!--内容区-->
					<div class="mui-card-content msgContent">{{msg.content}}</div>
				</div>
			</div>
		</div>
		<div class="mui-content" v-else>
			<div class="norecord">
				<img src="../assets/imgs/noInfo.png" class="noInfo"/>
				<p>暂无数据</p>
			</div>
		</div>
	</div>
</template>
<script>
	import { MessageInfo } from '@/request/api';
	export default{
		data: function(){
			return {
				msgList: []
			}
		},
		created(){
			this.getMsg();
		},
		methods:{
			getMsg(){
				var tenant_id = sessionStorage.getItem("tenant_id");
				MessageInfo({     
			    	"tenant_id":tenant_id,
			   	}).then(res => {
			    	// 获取数据成功后的其他操作
			    	if(res.result =='true'){
			    		this.msgList = res.data;
			    	}
			    	else{
			    		mui.toast(res.description,{ duration:'long'});	
			    	}
		  		}) 
			},
			goAddMoney(){
				//立即充值
				this.$router.push({path: '/home'});
			}
		}
	}
</script>
<style>
	 @import '../common/css/public.css';
</style>


// WEBPACK FOOTER //
// src/pages/toMsgCenter.vue